import { AppState } from '@core/state';
import { createChildSelectors } from '@util/lib/ngrx-child-selectors';

import { initialState } from './auth.reducers';

export const selectAuthState = (state: AppState) => state.auth;

export const {
  selectAuthenticated,
  selectChangePending,
  selectScreens,
  selectUser,
  selectSessionTimeout,
  selectSessionTimeoutTime,
  selectPermissions,
  selectTheme,
  selectId,
  selectApp,
} = createChildSelectors(selectAuthState, initialState);

export const { selectCurrentScreen, selectDistinctPreviousScreen, selectPreviousScreen } = createChildSelectors(
  selectScreens,
  initialState.screens
);

export const {
  selectAllcusts,
  selectChgfacility,
  selectCustid,
  selectEnv,
  selectFacility,
  selectLanguage,
  selectNameid,
  selectGroupid,
  selectCustomerAux,
} = createChildSelectors(selectUser, initialState.user);

export const { selectHasPassThru } = createChildSelectors(selectCustomerAux, initialState.user.customerAux);

export const { selectEnv: selectAppEnv } = createChildSelectors(selectApp, initialState.app);
